import styled from "styled-components";
import { FaFilePen, FaTrash, FaEnvelope, FaPlus } from 'react-icons/fa6';
import { useState, useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import execute from "hooks/execute";
import { protectedResources } from 'config/msalConfig';
import DeleteConfirmationModal from "components/shared/DeleteConfirmationModal";
import { Badge, Button, Space, Table, Input, Tag } from "antd";
import ShareInvitationModal from "components/shared/ShareInvitationModal";
import qs from 'qs';
import { DataEditor } from "./DataEditor";
import OrgModuleData from "components/shared/OrganizationModules/OrgModuleData";
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';



function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');  // Adjust 'en-US' as needed for your locale
}

function OrgCustData({ organization, searchResults }) {    
    const [isDataEditorOpen, setIsDataEditorOpen] = useState(false);        
    const [editableDataItem, setEditableDataItem] = useState({});

    const [currentRecord, setCurrentRecord] = useState(null);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const { orgId } = useParams();
    const location = useLocation();
    const [customers, setCustomers] = useState(searchResults || []);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    const [inviteInfo, setInviteInfo] = useState({ name: '', email: '', link: '' });
    const [invitedCustomerId, setInvitedCustomerId] = useState(null);
    const [customerPlanMap, setCustomerPlanMap] = useState({});

    const [tableParams, setTableParams] = useState({
        pagination: {
          current: 1,
          pageSize: 10,
        },
    });

    const openEditorToAdd = () => {
        console.log("openEditorToAdd");
        setEditableDataItem({Org_ID: orgId});
        setIsDataEditorOpen(true);
    };

    const openEditorToEdit = (record) => {
        console.log("edit", record);
        setEditableDataItem(record);
        setIsDataEditorOpen(true);
    };

    //searchFilter
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
            padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
                marginBottom: 8,
                display: 'block',
            }}
            />
            <Space>
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                width: 90,
                }}
            >
                Search
            </Button>
            <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                width: 90,
                }}
            >
                Reset
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({
                    closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
                }}
            >
                Filter
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                close();
                }}
            >
                close
            </Button>
            </Space>
        </div>
        ),
        filterIcon: (filtered) => (
        <SearchOutlined
            style={{
            color: filtered ? '#1677ff' : undefined,
            }}
        />
        ),
        onFilter: (value, record) =>
        record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        filterDropdownProps: {
        onOpenChange(open) {
            if (open) {
            setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        },
        render: (text) =>
        searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });

  //endSearchFilter

    const columns = [
        {
            title: 'Created On',
            dataIndex: 'CreatedOn',
            key: 'CreatedOn',
            sorter: true,
            width: '9%',
            render: (text) => formatDate(text),
        },
        {
            title: 'Customer Name',
            dataIndex: 'CustomerName',
            key: 'CustomerName',
            sorter: true,
            width: '12%',
            ...getColumnSearchProps('CustomerName'),
        },
        {
            title: 'Domain Name',
            dataIndex: 'Domain',
            key: 'Domain',
            sorter: true,
            width: '10%',
            ...getColumnSearchProps('Domain'),
        },
        {
            title: 'Address',
            dataIndex: 'Address',
            key: 'Address',
            sorter: true,
            width: '9%',
            ...getColumnSearchProps('Address'),

        },
        {
            title: 'Workspace Name',
            dataIndex: 'Workspace_Name',
            key: 'Workspace_Name',
            sorter: true,
            width: '11%',
            ...getColumnSearchProps('Workspace_Name'),

        },
        {
            title: 'Database Name',
            dataIndex: 'DatabaseName',
            key: 'DatabaseName',
            sorter: true,
            width: '10%',
            ...getColumnSearchProps('DatabaseName'),

        },
        {
            title: 'Cust Admin',
            dataIndex: 'CustEmail',
            key: 'CustEmail',
            sorter: true,
            width: '14%',
            ...getColumnSearchProps('CustEmail'),

        },
        {
            title: 'AI Plan',
            key: 'aiPlan',
            width: '11%',
            className: 'table-ai-plan',
            render: (_, record) => {
                const planInfo = customerPlanMap[record.Customer_ID];
                if (!planInfo) {
                    return <Tag>No Plan</Tag>;
                }

                if (!planInfo.hasAssignment) {
                    return <Tag>No Plan</Tag>;
                }

                return (
                    <Space size={4}>
                        <Tag color={planInfo.status === 'Cancelled' ? 'default' : 'gold'}>
                            {planInfo.planName}
                        </Tag>
                        {planInfo.status ? (
                            <Tag color={planInfo.status === 'Cancelled' ? 'red' : (planInfo.status === 'Scheduled' ? 'blue' : 'green')}>
                                {planInfo.status}
                            </Tag>
                        ) : null}
                    </Space>
                );
            }
        },
        {
            title: <Button color="default" variant="text" onClick={ openEditorToAdd } icon={<FaPlus  style={{ color: '#ffad1c' }} />} />,
            key: 'actions',
            width: 90,
            align: 'center',
            className: 'table-actions',
            render: (text, record) => (
                <Space size={4}>
                    <Button  color="default" variant="text"  title="Resend the invitation" onClick={(e) => {
                        e.stopPropagation();
                        handleSendInvitation(record);
                    }} icon={<FaEnvelope style={{ color: '#ffad1c' }} />} />
                                            
                    <Button   color="default" variant="text" onClick={(e) => {
                        e.stopPropagation(); // Prevent row click
                        openEditorToEdit(record);
                    }} icon={<FaFilePen  style={{ color: '#ffad1c' }} />} />
                                        
                    <Button   color="default" variant="text" onClick={(e) => {
                        e.stopPropagation(); // Prevent row click
                        handleDelete(record);
                    }} icon={<FaTrash style={{ color: '#ffad1c' }} />} />
                </Space>
                
            ),
        },
    ];

    const handleDataEditFinished = (newData) => {
        console.log("handleDataEditFinished", newData, editableDataItem);
        setIsDataEditorOpen(false);
        fetchData();
    };

    const handleDataEditCancelled = () => {
        console.log("handleDataEditCancelled");
        setIsDataEditorOpen(false);
    };


    const getTableParams = (params) => ({
        pS: params.pagination?.pageSize,
        pN: params.pagination?.current,
        sF: params.sortField,
        sO: params.sortOrder,
        f: params.filters
        // ...params,
    });

    const handleSendInvitation = async (record) => {
        try {
        var response = await execute('POST', `${protectedResources.api.baseEndPoint}/customers/sendSignupInvitationToCustomer`, {
            Customer_ID: record.Customer_ID,
            sendEmail: false
        });
        if(response.success){
          const data = response.data || {};
          setInviteInfo({
            name: data.customerName || record.CustomerName || '',
            email: data.email || record.CustEmail || '',
            link: data.inviteLink || ''
          });
          setInvitedCustomerId(record.Customer_ID);
          setInviteModalOpen(true);
        }else{
          throw new Error(response.message || 'Failed to send invitation');
        }
        }catch(error){
          alert('Failed to send invitation: ' + error.message);
        }
    };

    const handleDelete = (record) => {
        setCurrentRecord({ ...record });
        setDeleteModalOpen(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await execute('DELETE', `${protectedResources.api.baseEndPoint}/customers`, {
                    custId: currentRecord.Customer_ID
                });
            if (response.success) {
                alert('User deleted successfully.');
                await fetchData(); // Refetch data after deletion
            } else {
                setError(response.message || 'Failed to delete user');
            }
        } catch (error) {
            alert('Failed to delete user: ' + error.message);
        }
        setDeleteModalOpen(false);
    };

    const hydrateCustomerPlanMap = async (customerRows) => {
        if (!Array.isArray(customerRows) || customerRows.length === 0) {
            setCustomerPlanMap({});
            return;
        }

        try {
            const responses = await Promise.all(
                customerRows.map((row) =>
                    execute(
                        'GET',
                        `${protectedResources.api.baseEndPoint}/ai-subscription/assignments?scopeType=CUSTOMER&scopeId=${row.Customer_ID}&status=Active`
                    )
                )
            );

            const now = new Date();
            const nextMap = {};
            customerRows.forEach((row, index) => {
                const data = responses[index]?.success && Array.isArray(responses[index].data) ? responses[index].data : [];
                const assignment = data.find((a) => {
                    const start = a.StartDate ? new Date(a.StartDate) : null;
                    const end = a.EndDate ? new Date(a.EndDate) : null;
                    return (!start || start <= now) && (!end || end > now);
                }) || data[0];

                if (assignment?.PlanName) {
                    nextMap[row.Customer_ID] = { planName: assignment.PlanName, status: assignment.Status || null, hasAssignment: true };
                } else {
                    nextMap[row.Customer_ID] = { planName: 'No Plan', status: null, hasAssignment: false };
                }
            });

            setCustomerPlanMap(nextMap);
        } catch (error) {
            console.error('Failed to fetch AI plan badges for customers:', error);
            setCustomerPlanMap({});
        }
    };

    const fetchData = async (params = tableParams) => {
        try {
            setLoading(true);
            console.log(getTableParams(params))
            const response = await execute('GET', `${protectedResources.api.baseEndPoint}/organizations/${orgId}/customers?${qs.stringify(getTableParams(params))}`);
            if (response.success && response.data.length > 0) {
                console.log("customerData///////////")
                console.log(response.data)
                setCustomers(response.data);
                await hydrateCustomerPlanMap(response.data);
                setTableParams((prev) => {
                    const nextTotal = Number(response.totalRecords || 0);
                    if (prev?.pagination?.total === nextTotal) {
                        return prev;
                    }
                    return {
                        ...prev,
                        pagination: {
                            ...prev.pagination,
                            total: nextTotal,
                        },
                    };
                });
                setError('');
            } else {
                setCustomers([]);
                setCustomerPlanMap({});
                setTableParams((prev) => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        total: 0,
                    },
                }));
                setError(response.message || 'No customers found for the specified organization');
            }
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch data: ' + err.message);
            setLoading(false);
        }
    };
    useEffect(() => {
        if(orgId){
            fetchData(tableParams);
        }
    }, [orgId, 
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        // searchText
        tableParams?.filters,
    ]);

    useEffect(() => {
        if (searchResults) {
            setCustomers(searchResults);
        }
    }, [searchResults]);

    // Auto-expand customer row when navigating from search results
    useEffect(() => {
        if (location.state?.expandCustomerId && customers.length > 0) {
            setExpandedRowKeys([location.state.expandCustomerId]);
        }
    }, [location.state, customers]);

    const handleTableChange = (pagination, filters, sorter) => {
        console.log("filters change")
        console.log(filters)
        console.log('handleTableChange', pagination, filters, sorter);

        // Filter out null or empty values
        const cleanedFilters = Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => value && value.length > 0)
        );

        console.log(cleanedFilters)

        setTableParams((prev) => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                ...pagination,
            },
            filters: cleanedFilters,
            sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
            sortField: Array.isArray(sorter) ? undefined : sorter.field,
        }));
    
        // `dataSource` is useless since `pageSize` changed
        if (pagination.pageSize !== tableParams.pagination?.pageSize) {
          setCustomers([]);
        }
    };

    const handleCopyInvite = async () => { try { await navigator.clipboard.writeText(inviteInfo.link || ''); } catch (_) {} };
    const handleResendEmail = async () => {
        const response = await execute('POST', `${protectedResources.api.baseEndPoint}/customers/sendSignupInvitationToCustomer`, { Customer_ID: invitedCustomerId, inviteLink: inviteInfo.link, sendEmail: true });
        if (!response.success) {
            throw new Error(response.message || 'Failed to send invitation');
        }
        return true;
    };

    const expandedRowRender = (record) => (
        <OrgModuleData customer={record} highlightUserId={location.state?.highlightUserId} />
    );
    const handleExpand = (expanded, record) => {
        if (expanded) {
            setExpandedRowKeys([...expandedRowKeys, record.Customer_ID]);
        } else {
            setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.Customer_ID));
        }
    };

    return (
        <>
        <TableContainer>
            <Table
                className="org-customers-table"
                tableLayout="fixed"
                size="small"
                columns={columns}
                rowKey={record => record.Customer_ID}
                dataSource={customers}
                pagination={tableParams.pagination}
                loading={loading}
                expandable={{
                    expandedRowRender,
                    expandedRowKeys: expandedRowKeys,
                    onExpand: handleExpand,
                }}
                onChange={handleTableChange } />      
            { isDataEditorOpen ? 
                <DataEditor 
                    isOpen={isDataEditorOpen} 
                    dataItem={editableDataItem} 
                    onDataEditorFinished={handleDataEditFinished} 
                    onDataEditorCancelled={handleDataEditCancelled} /> 
                    : null }
            {isDeleteModalOpen && <DeleteConfirmationModal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)} record={currentRecord} onDeleteConfirmed={handleConfirmDelete} />}
        </TableContainer>
        {inviteModalOpen && (
            <ShareInvitationModal
                isOpen={inviteModalOpen}
                name={inviteInfo.name}
                email={inviteInfo.email}
                inviteLink={inviteInfo.link}
                onCopyLink={handleCopyInvite}
                onSendEmail={handleResendEmail}
                onClose={() => setInviteModalOpen(false)}
            />
        )}
        </>
    );
}

const TableContainer = styled.div`
    border-radius: 0px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    width: 100%;
    max-width: 100%;

    .org-customers-table .ant-table {
        width: 100%;
    }

    .org-customers-table .ant-table table {
        table-layout: fixed;
        width: 100%;
    }

    .org-customers-table .ant-table-cell {
        white-space: nowrap;
        word-break: normal;
        overflow-wrap: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 10px 8px;
        vertical-align: middle;
    }

    .org-customers-table .ant-table-thead > tr > th {
        white-space: nowrap;
        word-break: normal;
        overflow-wrap: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 600;
    }

    .org-customers-table .ant-table-column-title {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .org-customers-table .table-actions .ant-space {
        width: 100%;
        justify-content: flex-start;
        flex-wrap: nowrap;
        gap: 2px;
    }

    .org-customers-table th.table-actions,
    .org-customers-table td.table-actions {
        overflow: visible;
        text-overflow: clip;
        white-space: nowrap;
        padding-left: 4px;
        padding-right: 4px;
    }

    .org-customers-table td.table-actions .ant-btn {
        min-width: 22px;
        padding-inline: 2px;
    }

    .org-customers-table th.table-ai-plan,
    .org-customers-table td.table-ai-plan {
        white-space: nowrap;
        overflow: visible;
        text-overflow: clip;
    }

    @media (max-width: 1366px) {
        .org-customers-table .ant-table-cell {
            padding: 8px 6px;
            font-size: 12px;
            line-height: 1.3;
        }
    }
`;



export default OrgCustData;
